import _get from "lodash.get";

export default {
	data() {
		return {
			activeModal: []
		}
	},
	computed:{
		allWorkspaces: function(){
			return _get(this.userInfo,'allWorkspaces',[])
		},
		workspaceId: function(){
			return this.$router.currentRoute.params.workspaceId || this.allWorkspaces[0];
		}
	},
	methods: {
		validateEmail(email) {
			const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		},
		formattedData: (seconds, needConvertToday=false, shortMonth = false)=> {
			const monthText = shortMonth
				? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
				: ['January','February','March','April','May','June','July','August','September','October','November','December'];
			const retroDateMilliSec = new Date(seconds * 1000);
			const now = new Date();
			const retroDate = {
				d: retroDateMilliSec.getDate(),
				m: retroDateMilliSec.getMonth(),
				y: retroDateMilliSec.getFullYear()
			};
			const nowDate = {
				d: now.getDate(),
				m: now.getMonth(),
				y: now.getFullYear()
			};

			if (retroDate.d === nowDate.d && retroDate.m === nowDate.m && retroDate.y === nowDate.y) {
				return 'Today';
			}
			if (retroDate.d + 1 === nowDate.d && retroDate.m === nowDate.m && retroDate.y === nowDate.y) {
				return 'Yesterday';
			}

			return monthText[retroDate.m] + ' ' + retroDate.d + ', ' + retroDate.y;
		},
		hideFirstModal() {
			this.activeModal.shift();
		},
		generateId4() {
			return Math.random().toString(36).substring(2, 6)
		},
		currentWorkspaceCheck() {
		},
		userInfoCheck() {
		},
		workspacesCheck() {
		},
		setCurrentWorkspaceMixin() {
			if (!this.workspaces) return;
			if (this.allWorkspaces.includes(this.workspaceId) && !this.currentWorkspace) {
				this.$store.dispatch('action_SetCurrentWorkspace', { workspaceId:this.workspaceId });
			}
		},
		subscribeAllWorkspacesMixin() {
			if (!this.userInfoLoaded) return;
			if (this.allWorkspaces.length===0){return  this.$router.push('/create-team')}

			if (!this.allWorkspaces.includes(this.workspaceId)) {
				return this.$router.push('/404');
			} else {
				this.allowedWorkspace = true;
			}

			if (this.workspaces) return;
			this.$store.dispatch('action_subscribeAllWorkspaces');
		}
	},
	watch: {
		currentWorkspace: function () {
			this.currentWorkspaceCheck();
		},
		userInfo: function () {
			this.userInfoCheck();
		},
		workspaces: function () {
			this.workspacesCheck();
		}
	},
	mounted() {
		this.userInfoCheck();
		this.currentWorkspaceCheck();
		this.workspacesCheck();
	}
}